import { DocumentNode, gql } from '@apollo/client';

// Statisches Dokument mit GraphQL-Variablen (keine String-Interpolation mehr).
// Der correlationId-Wert wird als Variable übergeben und nie als Query-Text
// geparst -> keine (Stored) GraphQL-Injection.
export const getRecyclingProcessByCorrelationIdQuery: DocumentNode = gql`
  query GetRecyclingProcessByCorrelationId($correlationId: String!) {
    recyclingProcessByCorrelationId(correlationId: $correlationId) {
      id
      correlationId
      processStart
      chosenProductCategory {
        id
        name
      }
      chosenManufacturer
      country {
        id
        name
        countryCode
        logisticTypeId
        localPartnerEmail
      }
      trackingId
      dateOfArrival
      dateOfCancellation
      arrivedProductCategory {
        id
        name
      }
      serialNumber
    }
  }
`;
